/* global femcare */

/**
 * Handles the initialization and animation of infographic components when they come into the viewport.
 */
femcare.article.infographic = {
    /**
     * Initializes the infographic component.
     * Attaches event listeners to monitor when the infographic enters the viewport.
     */
    init() {
        const $infographic = $('.infographic');
        if ($infographic.length) {
            this.animationStarted = false;
            this.$animationStartline = $('.infographic__animation-startline');
            this.handleScroll = () => this.conditionallyStartAnimation();

            $(window).on('wheel scroll resize', this.handleScroll);
            this.conditionallyStartAnimation();
        }
    },

    /**
     * Checks if the infographic is in the viewport and triggers the animation if not already started.
     * Removes event listeners once the animation starts.
     */
    conditionallyStartAnimation() {
        if (
            !this.animationStarted &&
            femcare.shared.util.isElementInViewport(this.$animationStartline)
        ) {
            this.animationStarted = true;
            $(window).off('wheel scroll resize', this.handleScroll);
            this.animate();
        }
    },

    /**
     * Animates the infographic components.
     * This includes initializing the CountUp animation and animating progress circles using circleProgress.
     */
    animate() {
        $('.infographic-column').each((_, element) => {
            const $column = $(element);
            const $progressCircle = $column.find('.infographic-column__circle');
            const canvasSupported = !!window.HTMLCanvasElement;

            // Parse data attributes with safe defaults
            const fillPercent = parseInt(($column.data('fill') || 100).toString().trim(), 10);
            const countUpTo = parseInt(($column.data('countupto') || 0).toString().trim(), 10);

            // Initialize CountUp if required
            const $statsSpan = $column.find('.infographic-column__stats span')[0];
            const CountUpConstructor = window.CountUp;
            const counter = countUpTo && CountUpConstructor
                ? new CountUpConstructor($statsSpan, countUpTo, {
                    startVal: 0,
                    duration: 2,
                    useEasing: true,
                    useGrouping: true,
                })
                : null;

            // Start animations with a small delay
            setTimeout(() => {
                if (counter && !counter.error) {
                    counter.start();
                } else if (counter && counter.error) {
                    console.error(counter.error);
                }

                if (canvasSupported) {
                    const isRTL = $('body').hasClass('rtl');

                    $progressCircle.circleProgress({
                        value: fillPercent / 100,
                        size: 215,
                        thickness: 4,
                        startAngle: Math.PI - 67.5,
                        fill: { gradient: ['#e31d93', ['#ef5a9e', 0.54], '#e31d1d'] },
                        emptyFill: '#dddddd',
                        reverse: isRTL,
                    });
                }
            }, 10);
        });
    },
};
